/** 当前登录类型 */
export enum LoginTypeEnum {
  /** 联登，调用平台联登方案 */
  UNION = 'UNIONAUTH',
  /** 走bridge 登录，预留字段 */
  BRIDGE = 'BRIDGE',
}
